module.exports = __webpack_public_path__ + "img/cardImg.289b8973.png";